import { RVSCompany } from "@eres/rvsapi/entities";
import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { IsCompanyHasSelComplainType, RenderCompanySearchResults } from "./CompanySearchPopup";
import { LocaleUtil } from "@eres/core";

interface Props {
	complainTypeID?: number;
	companies: RVSCompany[];
	onClose: () => void;
	onCompanySelect: ( company: RVSCompany ) => void;

}

interface State {
	companySelError?: string;
}

class MollakCompaniesPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {};
	}

	render() {
		const { companies } = this.props;
		const { companySelError } = this.state;
		return <Popup
			autoOpenMount={ true }
			id={ "mollak_companies_popup" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			showIcon={ false }
			title={ Strings.select_company_to_register_complain }
			onDismiss={ this.onClose }>
			<RenderCompanySearchResults
				companies={ companies }
				onCompanySelect={ this.onCompanySelect }
				error={ companySelError }/>
		</Popup>;
	}

	private onClose = () => {
		this.props.onClose();
	};

	private onCompanySelect = ( company: RVSCompany ) => {
		if ( IsCompanyHasSelComplainType( company, this.props.complainTypeID ) ) {
			this.props.onCompanySelect( company );
		} else {
			const companyName = LocaleUtil.getLocalValue( company );
			this.setState( {
				companySelError: Strings.rvs_company_complaint_type_mismatch.replace( "~", "\"" + companyName + "\"" ),
			} );
		}
	};
}

export default MollakCompaniesPopup;
